import BadgeCheckIcon from '@liquidweb-dev/undercurrent/icons/lucide/BadgeCheck';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import { type LucideSvgProps } from '@liquidweb-dev/undercurrent/types/svgTypes';
import Typography, {
	type TypographyProps,
} from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

const buildText = (ssls: number, hasWildcard: boolean) => {
	if (ssls > 1) {
		return `${ssls} SSLs`;
	}

	if (ssls === 1) {
		return hasWildcard ? 'Wildcard' : 'Standard';
	}

	return null;
};

export interface SslAttributeProps extends StackProps {
	ssls: number;
	hasWildcard: boolean;
	iconProps?: LucideSvgProps;
	typographyProps?: TypographyProps;
}

const SslAttribute = ({
	ssls,
	hasWildcard,
	sx,
	iconProps,
	typographyProps,
	...rest
}: SslAttributeProps) => {
	const { sx: iconSx, ...restIconProps } = iconProps || {};
	const { sx: typographySx, ...restTypographyProps } = typographyProps || {};

	return (
		<Stack
			sx={combineSx(
				({ vars }) => ({
					flexDirection: 'row',
					alignItems: 'center',
					color: vars.palette.uc.highlight.text.main,
					gap: 50,
				}),
				sx,
			)}
			{...rest}
		>
			<BadgeCheckIcon
				sx={combineSx(
					({ size }) => ({
						width: size.xS,
						height: size.xS,
						flexShrink: 0,
					}),
					iconSx,
				)}
				{...restIconProps}
			/>
			<Typography
				variant="label-lg"
				sx={combineSx(
					{
						fontWeight: 500,
					},
					typographySx,
				)}
				{...restTypographyProps}
			>
				{buildText(ssls, hasWildcard)}
			</Typography>
		</Stack>
	);
};

export default SslAttribute;
